import React, {useEffect, useState} from 'react';
import {Layout, Space} from 'antd';
import s from './PersonalAccount.module.css'
import {Outlet, useNavigate} from 'react-router-dom';
import '../../components/SideMenu/index.css'
import classnames from "classnames";
import {useAppDispatch, useAppSelector} from "../../hooks/redux";
import {
    getKycListThunk,
    getTransactionsListThunk, getUserEmailsListThunk,
    LogoutThunk,
} from "../../store/reducers/ActionCreators";
import {motion} from 'framer-motion';
import MyBtn from "../../components/ui/MyBtn/MyBtn";
import CustomModal from "../../components/ui/CustomModal/CustomModal";
import styles from "../../components/ContactUsForm/ContactUsForm.module.css";
import SideMenu from "../../components/SideMenu/SideMenu";
import CustomModalContactContainer from "../../components/ui/CustomModalContactContainer/CustomModalContactContainer";

const {Header, Content} = Layout;

const SIDEMENU_COLLAPSED_KEY = 'sideMenuCollapsed';

const headerStyle: React.CSSProperties = {
    color: '#fff',
    height: "auto",
    backgroundColor: 'transparent',
    margin: '48px 24px 36px 264px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0',
    transition: 'all 0.3s ease'
};

const headerStyleCollapsed: React.CSSProperties = {
    color: '#fff',
    height: "auto",
    backgroundColor: 'transparent',
    margin: '48px 24px 36px 104px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0',
    transition: 'all 0.3s ease'
};

const contentStyle: React.CSSProperties = {
    minHeight: '100vh',
    color: '#000',
    backgroundColor: '#F6F9FF',
    padding: '0 24px 69px 264px',
    transition: 'all 0.3s ease'
};

const contentStyleCollapsed: React.CSSProperties = {
    minHeight: '100vh',
    color: '#000',
    backgroundColor: '#F6F9FF',
    padding: '0 24px 69px 104px',
    transition: 'all 0.3s ease'
};

const contentStyleMobile: React.CSSProperties = {
    minHeight: '100vh',
    color: '#000',
    backgroundColor: '#F6F9FF',
    padding: '0 16px',
};



const PersonalAccount = () => {

    const firstName = useAppSelector((state) => state.userReducer.user.userData.firstName);
    const lastName = useAppSelector((state) => state.userReducer.user.userData.lastName);
    const companyName = useAppSelector((state) => state.userReducer.user.userData.companyName);
    const isTokenValid = useAppSelector((state) => state.userReducer.tokenIsValid);

    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSideMenuCollapsed, setIsSideMenuCollapsed] = useState(() => {
        const savedState = localStorage.getItem(SIDEMENU_COLLAPSED_KEY);
        return savedState ? JSON.parse(savedState) : false;
    });
    const dispatch = useAppDispatch();

    const token = useAppSelector((state) => state.userReducer.user.userToken);

    useEffect(() => {
        if (token && isTokenValid) {
            dispatch(getKycListThunk(token));
            dispatch(getTransactionsListThunk(token));
            dispatch(getUserEmailsListThunk(token))
        }
    }, [dispatch, token, isTokenValid]);

    useEffect(() => {
        localStorage.setItem(SIDEMENU_COLLAPSED_KEY, JSON.stringify(isSideMenuCollapsed));
    }, [isSideMenuCollapsed]);

    const handleLogout = () => {
        dispatch(LogoutThunk())
            .then(() => {
                navigate("/login");
            })
    }

    const toggleSideMenu = () => {
        setIsSideMenuCollapsed(!isSideMenuCollapsed);
    };

    return (
        <div>
            <motion.div
                initial={{opacity: 0, scale: 1}}
                animate={{opacity: 1, scale: 1}}
                transition={{duration: 0.5}}
            >

                <CustomModal isModalOpen={!isTokenValid} type={"confirm"}>
                    <div className={styles.popup_title}>
                        Oops!
                    </div>
                    <div className={styles.popup_subtitle}>
                        Your session time has been expired. Please login once again.
                    </div>
                    <div className={styles.popup_button_wrapper}>
                        <div className={styles.button_block}>
                            <MyBtn title={"Ok"} buttonType={"confirm"} onClick={() => handleLogout()}/>
                        </div>
                    </div>
                </CustomModal>

                <CustomModalContactContainer setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen}/>

                <div className={s.wrapper_desktop}>
                    <div className={classnames(s.toggle_button_container, isSideMenuCollapsed && s.collapsed)}>
                        <button 
                            className={s.toggle_button}
                            onClick={toggleSideMenu}
                            aria-label={isSideMenuCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                            aria-expanded={!isSideMenuCollapsed}
                            title={isSideMenuCollapsed ? "Expand sidebar" : "Collapse sidebar"}
                        >
                            <div className={classnames(s.toggle_icon, isSideMenuCollapsed && s.collapsed)}></div>
                        </button>
                    </div>
                    
                    <Space direction="vertical" style={{width: '100%', position: "relative", background: '#F6F9FF'}}
                           size={[0, 0]}>
                        <Layout style={{background: '#F6F9FF', position: 'relative'}}>
                            <SideMenu collapsed={isSideMenuCollapsed} />
                            
                            <Layout style={{ background: '#F6F9FF', marginLeft: 0 }}>
                                {<div className={s.header_wrapper}>
                                    <Header style={isSideMenuCollapsed ? headerStyleCollapsed : headerStyle}>
                                        <div className={s.left}>
                                            <div className={s.icons_block}>
                                                <div className={s.round} onClick={() => setIsModalOpen(true)}>
                                                    <div className={s.mail}></div>
                                                </div>
                                                {/*<div className={s.round}>*/}
                                                {/*    <img className={s.icon_point} src={icon_point} alt=""/>*/}
                                                {/*    <div className={s.chat}></div>*/}
                                                {/*</div>*/}
                                            </div>
                                        </div>
                                        <div className={s.right}>
                                            <div className={s.user_round}>
                                                {firstName?.slice(0, 1)}{lastName?.slice(0, 1)}{companyName?.slice(0, 1)}
                                            </div>
                                        </div>
                                    </Header>
                                </div>}
                                <Content style={isSideMenuCollapsed ? contentStyleCollapsed : contentStyle}>
                                    <Outlet/>
                                </Content>
                            </Layout>
                        </Layout>
                    </Space>
                </div>
                <div className={s.wrapper_mobile}>
                    <Space direction="vertical" style={{width: '100%', position: "relative", background: '#F6F9FF'}}
                           size={[0, 0]}>
                        <Layout style={{background: '#F6F9FF'}}>
                            <Layout>
                                <Content style={contentStyleMobile}>
                                    <Outlet/>
                                </Content>
                            </Layout>
                        </Layout>
                    </Space>
                </div>
            </motion.div>
        </div>
    );
};

export default PersonalAccount;
